import BookPage from 'components/finance/BookPage';

/** Admin › Finanzas › Flujo de caja: la caja menor en efectivo. */
export default function FinanzasFlujoCaja() {
  return <BookPage book="caja_menor" />;
}
